import { Box } from "@/components/layout/flexbox";
import { Col, Container, Row } from "@/components/pieces/bootstrap";
import { FaqCategory } from "@/components/pieces/faq/FaqCategory";

interface FAQProps {
  category?: string;
}

export function FAQ({ category = "Basics" }: FAQProps) {
  return (
    <Box py={70}>
      <Container>
        <Row>
          <Col width={[1, 1, 2 / 3]} ml={[1, 1, "16.66666667%"]}>
            <Box className="text-center" mb={4}>
              <h2 style={{ color: "#2D2750", fontSize: 36, margin: 0 }}>
                Common Questions
              </h2>
            </Box>
            <FaqCategory category={category} />
          </Col>
        </Row>
      </Container>
    </Box>
  );
}
